module.exports = __webpack_public_path__ + "static/media/class_bg.e0531ca3.jpeg";